import { IdentificationIndividual } from '@/graphql/types'

export const findIndividualIndex = (
  individuals: (IdentificationIndividual | null)[] | undefined,
  individual: Partial<IdentificationIndividual>
) => {
  let individualIndex = individuals?.findIndex(val => val?.id && val?.id === individual.id) ?? -1
  if (individualIndex === -1)
    individualIndex =
      individuals?.findIndex(
        val =>
          val?.emailAddress === individual.emailAddress &&
          val?.firstName === individual.firstName &&
          val?.surname === individual.surname
      ) ?? -1

  return individualIndex
}
